import { gql } from '@apollo/client';

export const SEND_MESSAGE = gql`
  query search($query: String!, $previousResponseId: String) {
    search(query: $query, previousResponseId: $previousResponseId) {
      id
    }
  }
`;

export const AI_MESSAGE = gql`
  subscription aiSearchCompleted($hash: String!) {
    aiSearchCompleted(hash: $hash) {
      id
      model
      query
      responseId
      response
      posts {
        id
        videoId
        urlParam
        title
        thumbnail
        price
      }
      flipbooks
      startedAt
      completedAt
      status
    }
  }
`;
